import React, {useEffect, useRef, useState} from "react";

import Slider from "react-slick";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
const ProjectDetailsModal = ({darkTheme, projectDetails}) => {
    const {t} = useTranslation();
    const sliderRef = useRef();
    const form = useRef();
    const [sendingMail, setSendingMail] = useState(false);
    const [email, setEmail] = useState('');
    const [record_source] = useState('personal_web');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const sendSubscriber = (e) => {
        e.preventDefault();
        setSendingMail(true);
        const data = {
            "subscriber": {
                email,
                record_source
            }
        };
        fetch(`${process.env.REACT_APP_MAIN_API_ENDPOINT}/subscribers`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then(data => {
                setIsSubmitting(false);
                document.getElementById("contact-form").reset();
                toast.success(t('software_solutions.subscribe.success'), {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: darkTheme ? "dark" : "light",
                });
            })
            .catch(error => {
                console.error(error);
                setIsSubmitting(false);
                toast.error(t('software_solutions.subscribe.error'), {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: darkTheme ? "dark" : "light",
                });
            });
        setSendingMail(false);
        setEmail('');
    };

    var settings = {
        dots: true,
        arrows: false,
        infinite: true,
        adaptiveHeight: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                },
            },
        ],
    };

    useEffect(() => {
        sliderRef.current.slickGoTo(0);
    }, [projectDetails]);

    return (
        <>
            <div
                className="modal fade bg-dark-1"
                id="exampleModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl">
                    <div
                        className={
                            "modal-content " + (darkTheme ? "bg-dark-2 text-light" : "")
                        }
                    >
                        <div className="modal-body">
                            <button
                                type="button"
                                className={"btn-close " + (darkTheme ? "btn-close-white" : "")}
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                            <div
                                className={
                                    "container ajax-container " +
                                    (darkTheme ? "bg-dark-2 text-light" : "")
                                }
                            >
                                <h2
                                    className={
                                        "text-6 font-weight-600 text-center mb-4" +
                                        (darkTheme ? " text-white" : "")
                                    }
                                >
                                    {projectDetails?.title}
                                </h2>
                                <div className="row g-4">
                                    <div className="col-md-7">
                                        <Slider {...settings} ref={sliderRef}>
                                            <div className="item">
                                                <img
                                                    className="img-fluid"
                                                    alt={projectDetails?.title || "Proyecto de Software Solutions"}
                                                    src={projectDetails?.thumbImage}
                                                    loading="lazy"
                                                />
                                            </div>
                                            {projectDetails?.sliderImages?.length > 0 &&
                                                projectDetails?.sliderImages?.map((image, index) => (
                                                    <div className="item" key={index}>
                                                        <img
                                                            className="img-fluid"
                                                            alt={`${projectDetails?.title || "Proyecto"} vista ${index + 2}`}
                                                            src={image}
                                                            loading="lazy"
                                                        />
                                                    </div>
                                                ))}
                                        </Slider>
                                    </div>
                                    <div className="col-md-5">
                                        <h4
                                            className={
                                                "text-4 font-weight-600" +
                                                (darkTheme ? " text-white" : "")
                                            }
                                        >
                                            <b>{t('software_solutions.popup.description')}</b>
                                        </h4>
                                        <p>{projectDetails?.projectInfo}</p>
                                        <h4
                                            className={
                                                "text-4 font-weight-600 mt-4" +
                                                (darkTheme ? " text-white" : "")
                                            }
                                        >
                                            <b>{t('software_solutions.popup.details')}</b>
                                        </h4>
                                        <ul
                                            className={
                                                "list-style-2 " + (darkTheme ? "list-style-light" : "")
                                            }
                                        >
                                            <li>
                        <span
                            className={
                                "text-dark font-weight-600 me-2" +
                                (darkTheme ? " text-white" : "")
                            }
                        >
                          <b>{t('software_solutions.popup.technologies')}</b>
                        </span>
                                                {projectDetails?.technologies}
                                            </li>
                                            <li>
                        <span
                            className={
                                "text-dark font-weight-600 me-2" +
                                (darkTheme ? " text-white" : "")
                            }
                        >
                          <b>{t('software_solutions.popup.industries')}</b>
                        </span>
                                                {projectDetails?.industry}
                                            </li>
                                            <li>
                        <span
                            className={
                                "text-dark font-weight-600 me-2" +
                                (darkTheme ? " text-white" : "")
                            }
                        >
                         <b> URL:</b>
                        </span>
                                                <a
                                                    href={projectDetails?.url?.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {projectDetails?.url?.name}
                                                </a>
                                            </li>
                                        </ul>
                                        <div className="row no-gutters align-items-center">
                                            <div
                                                className={
                                                    "col-auto text-dark font-weight-600" +
                                                    (darkTheme ? " text-white" : "")
                                                }
                                            >
                                                <b>{t('software_solutions.popup.followus')}</b>
                                            </div>
                                            <div className="col-auto">
                                                <ul
                                                    className={
                                                        "social-icons" +
                                                        (darkTheme ? " social-icons-muted" : "")
                                                    }
                                                >
                                                    <li className="social-icons-facebook">
                                                        <a
                                                            data-toggle="tooltip"
                                                            href={projectDetails?.socialLinks?.facebook}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            data-original-title="Facebook"
                                                        >
                                                            <i className="fab fa-facebook-f"/>
                                                        </a>
                                                    </li>
                                                    <li className="social-icons-twitter">
                                                        <a
                                                            data-toggle="tooltip"
                                                            href={projectDetails?.socialLinks?.twitter}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            data-original-title="Twitter"
                                                        >
                                                            <i className="fab fa-twitter"/>
                                                        </a>
                                                    </li>
                                                    <li className="social-icons-youtube">
                                                        <a
                                                            data-toggle="tooltip"
                                                            href={projectDetails?.socialLinks?.youtube}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            data-original-title="youtube"
                                                        >
                                                            <i className="fab fa-youtube"/>
                                                        </a>
                                                    </li>
                                                    <li className="social-icons-instagram">
                                                        <a
                                                            data-toggle="tooltip"
                                                            href={projectDetails?.socialLinks?.instagram}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            data-original-title="Instagram"
                                                        >
                                                            <i className="fab fa-instagram"/>
                                                        </a>
                                                    </li>
                                                    <li className="social-icons-github">
                                                        <a
                                                            data-toggle="tooltip"
                                                            href={projectDetails?.socialLinks?.github}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            data-original-title="Github"
                                                        >
                                                            <i className="fab fa-github"/>
                                                        </a>
                                                    </li>
                                                    <li className="social-icons-email">
                                                        <a
                                                            data-toggle="tooltip"
                                                            href={projectDetails?.socialLinks?.mail}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            data-original-title="Email"
                                                        >
                                                            <i className="fas fa-envelope"/>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{backgroundColor: '#f8f9fb'}} className='pb-5'>
                <form
                    className={darkTheme ? "form-dark" : ""}
                    id="contact-form"
                    action="php/mail.php"
                    method="post"
                    ref={form}
                    onSubmit={sendSubscriber}
                >
                    <input type="hidden" name="record_source" value={record_source}/>

                    <h3 className="text-center" style={{fontSize: '1.75em'}}> {t('software_solutions.subscribe.title')}</h3>
                    <div className="row justify-content-center">
                        <div className="col-xl-4 d-flex justify-content-center mt-4">
                            <input
                                type="email"
                                className="form-control rounded-pill me-2"
                                placeholder={t('software_solutions.subscribe.email_field')}
                                aria-label={t('software_solutions.subscribe.email_field')}
                                aria-describedby="button-addon2"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </div>
                        <div className="col-xl-2 d-flex justify-content-center mt-4">
                            <button
                                className="btn btn-primary rounded-pill"
                                type="submit"
                                id="button-addon2"
                                disabled={isSubmitting}
                            >
                                {sendingMail ? (
                                    <>
                                            <span role="status" aria-hidden="true"
                                                  className="spinner-border spinner-border-sm align-self-center me-2"></span>
                                        {t('software_solutions.subscribe.sending')}
                                    </>
                                ) : (
                                    <>{t('software_solutions.subscribe.subscribe_button')}</>
                                )}
                            </button>
                        </div>
                    </div>
                </form>
                <div className="row justify-content-center">
                    <a href="https://www.softwaresolutions.com.mx/" target="_blank" rel="noreferrer"
                       className="text-center mt-4">www.softwaresolutions.com.mx</a>
                </div>
            </div>
        </>
    );
};

export default ProjectDetailsModal;
